import { TimelineTypes } from '../components/Timeline/timeLineTypes';
import { capitaliseFirst } from '../components/Timeline/utils/timeline';
import type {
  InsightSettingsData,
  MedicationSetting,
} from '../../lib/responses/getInsightSettings';

export function capitalize(s: string) {
  if (s === 'appointments') s = 'appointment';
  return capitaliseFirst(s);
}

const PATIENT_VISIT_GROUP_TYPES = [
  'Other patient visit',
  'In-patient admission',
  'ED presentation',
];

export function formatAndStringify(input: string) {
  // Use a regular expression to find and format the 'medicinalProductPack' value
  const regex = /(medicinalProductPack: )([^,]+, \d+)/;
  let formattedString = input.replace(regex, '$1"$2"');

  // Wrap property names in quotes
  formattedString = formattedString.replace(/(\b\w+\b)(?=:)/g, '"$1"');

  // Parse the string as a JSON object
  let jsonObject;
  try {
    jsonObject = JSON.parse(formattedString);
  } catch (e) {
    console.error('Error parsing JSON:', e);
    return null;
  }

  // Stringify the JSON object
  return jsonObject;
}

export function fetchmppId(
  insightSettings: InsightSettingsData,
  item: { medicinal_product_pack?: string },
): MedicationSetting['mpp_id'] | undefined {
  return insightSettings.medication_settings?.find(
    (x: MedicationSetting) =>
      x.medicinal_product_pack === item.medicinal_product_pack,
  )?.mpp_id;
}

export function stringifyReasons(changeReasons: Record<string, string[]>) {
  if (changeReasons) {
    let string = '';

    changeReasons['Other signs']?.forEach((reason) => {
      string += reason + ', ';
    });
    changeReasons['Warning signs']?.forEach((reason) => {
      string += reason + ', ';
    });
    changeReasons['Good signs']?.forEach((reason) => {
      string += reason + ', ';
    });
    return string.substring(0, string.length - 2);
  } else {
    return 'No change reasons';
  }
}

export const getOffcanvasTitle = (
  groupType: string,
  insightDetailsContent: any,
  itemGroupType?: string,
) => {
  let title = '';
  if (
    groupType === TimelineTypes.OBSERVATIONS ||
    itemGroupType === TimelineTypes.OBSERVATIONS
  ) {
    return null;
  }

  if (insightDetailsContent?.pd_prescription_record_link) {
    title = 'Prescription';
  } else if (
    insightDetailsContent?.pbs_item_id ||
    insightDetailsContent?.pd_dispense_record_link
  ) {
    title = 'Medication dispense';
  } else if (
    insightDetailsContent?.report_name &&
    insightDetailsContent?.document_id
  ) {
    title = 'Pathology and diagnostics';
  } else if (groupType === TimelineTypes.MONTH_EVENTS) {
    title = 'Month Events list';
  } else if (groupType === TimelineTypes.WEEK_EVENTS) {
    title = 'Week Events list';
  } else if (PATIENT_VISIT_GROUP_TYPES.includes(groupType)) {
    title = 'Patient visit';
  } else if (groupType == 'Conversations') {
    title = 'Conversation';
  } else {
    title = groupType;
  }

  return <h2 className="offcanvas-title">{title} details</h2>;
};

export const getColorClass = (groupType: string) => {
  if (groupType.startsWith('Meds')) return 'midblue';
  if (groupType.startsWith('Appointment')) return 'darkblue';
  if (
    groupType.startsWith('Diagnostic and Pathology') ||
    groupType.startsWith('Lipids and HDL') ||
    groupType.startsWith('Other services')
  )
    return 'violet';
  if (groupType.startsWith('Profile Checks')) return 'lightGrey';
  return 'midblue';
};
